import React from 'react';
import Logo from '../assets/Logo';
import './Footer.css';

export default function ({ children }) {
  return (
    <footer>
      {children || null}
      <div className="container">
        <Logo fill="#fff"/>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js